import React from 'react'; // eslint-disable-line

import { Divider, Grid, Typography, withStyles } from '@material-ui/core';
import { connect, MapStateToProps } from 'react-redux';
import { Section } from '../../../../../controls/section';
import { State } from '../../../../../redux/root-reducer';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { ContactCommsDetails } from '../../../../../contact-details/contact-details';
import { getCommunicationDetails } from '../../contact-details/contact-details-reducer';
import { LabeledValue } from '../../../../../controls/labeled-value';

interface OwnProps {}

interface StateProps {
    readonly communicationsDetails?: ContactCommsDetails[];
    isReadOnly: boolean;
}

type Props = OwnProps & StateProps & StyledComponent;
const communicationsDetailsView: React.FunctionComponent<Props> = ({
    classes,
    communicationsDetails,
}: Props) => {
    if (communicationsDetails === null || communicationsDetails === undefined) {
        return (
            <Grid item xs={12}>
                <Grid container justify="flex-start">
                    <Grid item xs={3} lg={2}>
                        <LabeledValue
                            label="Is there an additional person you would like to add"
                            value={'No'}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    return (
        <Section title={``}>
            {communicationsDetails &&
                communicationsDetails?.map((comm, index) => {
                    return (
                        <React.Fragment key={`contact-${index}`}>
                            {index > 0 ? (
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                            ) : (
                                ''
                            )}
                            <Grid item xs={12}>
                                <Grid container spacing={0} justify="space-between">
                                    <Grid container spacing={0} item xs={8} lg={10}>
                                        <Typography variant="subtitle2">
                                            Communication {index + 1}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-start">
                                    <Grid item xs={3} lg={2}>
                                        <LabeledValue
                                            label="Is there an additional person you would like to add"
                                            value={'Yes'}
                                        />
                                    </Grid>
                                    <Grid item xs={3} lg={2}>
                                        <LabeledValue
                                            label="Contract Person First Name"
                                            value={comm.firstName}
                                        />
                                    </Grid>
                                    <Grid item xs={3} lg={2}>
                                        <LabeledValue
                                            label="Contract Person Surname"
                                            value={comm.lastName}
                                        />
                                    </Grid>
                                    <Grid item xs={3} lg={2}>
                                        <LabeledValue
                                            label="Work phone number"
                                            value={comm.telephoneNumber}
                                        />
                                    </Grid>
                                    <Grid container justify="flex-start" item xs={12}>
                                        <Grid item xs={3} lg={2}>
                                            <LabeledValue
                                                label="Cell number"
                                                value={comm.cellphoneNumber}
                                            />
                                        </Grid>
                                        <Grid item xs={3} lg={2}>
                                            <LabeledValue
                                                label="Email Address"
                                                value={comm.emailAddress}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    );
                })}
        </Section>
    );
};
const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => ({
    communicationsDetails: getCommunicationDetails(state),
    isReadOnly: state.claimSession.readOnly,
});

const mapDispatchToProps = {};

export const CommunicationsDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(communicationsDetailsView));
